var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"loading-block"},[_c('video',{staticClass:"loading__video",attrs:{"autoplay":"","muted":"","loop":""},domProps:{"muted":true}},[_c('source',{attrs:{"src":"/loading/orfeu_loading.mp4","type":"video/mp4"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }